import axios from '../utils/axios';

export default function fetchConfidentialJobs(adminId, params) {
    return (
        axios.get('/admin/' + adminId + '/confidential-jobs', {params})
    )
}
